import { Routes } from '@angular/router';
import { PendingChangesGuard } from '../../guards/pending-changes.guard';

import { RegistrationWizardComponent } from './components/registration-wizard/registration-wizard.component';
import { RegistrationConfirmationComponent } from './components/registration-confirmation/registration-confirmation.component';

export const registrationRoutes: Routes = [
  {
    path: 'register',
    loadComponent: () => import('./components/registration-container/registration-container.component').then(c => c.RegistrationContainerComponent),
    children: [
      { path: '', component: RegistrationWizardComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'confirmation', component: RegistrationConfirmationComponent },
    ]
  },

];
